import { Component, inject } from '@angular/core';
import { UserService } from '@app/shared/services/User.Service';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'kp-initials',
  imports: [AvatarModule],
  templateUrl: './initials.component.html',
  styleUrl: './initials.component.scss'
})
export class InitialsComponent {

  #userInternalService = inject(UserService)

  getUserInitials(): string {

      let name: string = this.#userInternalService.getUserFullName();
      let initials: string = "";

      if (name == null || name == '') { return initials; }
      if (name.indexOf(' ') < 0) { return name.substring(0, 1); }

      let names: string[] = name.split(' ');

      for (let i: number = 0; i < (names.length > 2 ? 2 : names.length); i++) {
          initials += names[i].substring(0, 1);
      }

      return initials;
  }
}
